import React, { PropsWithChildren } from 'react';
import styles from './SGSBadge.module.scss';
import classnames from 'classnames';

type Props = React.HTMLAttributes<HTMLDivElement> & {
    color: 'blue' | 'orange' | 'gray' | 'darkblue' | 'darkorange';
    size?: 'small' | 'large';
    children: React.ReactNode;
    rounded?: boolean;
};

const SGSBadge: React.FC<PropsWithChildren<Props>> = ({
    color = 'gray',
    size = 'small',
    rounded = false,
    className,
    ...props
}) => {
    return (
        <div
            className={classnames(
                styles.badge,
                styles[`badge__${size}`],
                styles[`badge__${color}`],
                rounded && styles.badge__rounded,
                className,
            )}
            {...props}
        />
    );
};

export default SGSBadge;
